<template>
  <aside class="sidebar" :class="{ 'is-open': isOpen }">
    <div class="sidebar-header">
      <h1>Ontologi Wayang Purwa</h1>
      <nav class="nav-actions">
        <button @click="goHome">Halaman Utama</button>
        <button @click="goToVisualisasiFuseki">Visualisasi dari Fuseki</button>
        <button @click="goToTentangKami">Tentang Kami</button>
      </nav>
    </div>

    <div class="submenu">
      <h2>DAFTAR MENU</h2>
      <div class="menu-section">
        <h3>DATA INDIVIDU</h3>
        <ul>
          <li><button class="menu-link" @click="navigateTo('Tokoh')">Tokoh Wayang Purwa</button></li>
          <li><button class="menu-link" @click="navigateTo('Tempat')">Tempat Asal</button></li>
          <li><button class="menu-link" @click="navigateTo('Pusaka')">Pusaka</button></li>
          <li><button class="menu-link" @click="navigateTo('Kesaktian')">Kesaktian</button></li>
        </ul>
      </div>
      <div class="menu-section">
        <h3>VISUALISASI</h3>
        <ul>
          <li><button class="menu-link" @click="goToVisualisasi">Visualisasi Lokal</button></li>
        </ul>
      </div>
    </div>
  </aside>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'AppSidebar',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  setup(props, { emit }) {
    const router = useRouter()

    const closeSidebar = () => {
      emit('close')
    }

    const pushRoute = (name) => {
      router.push({ name })
      closeSidebar()
    }

    const goHome = () => {
      pushRoute('Home')
    }

    const goToVisualisasi = () => {
      pushRoute('Visualisasi')
    }

    const goToVisualisasiFuseki = () => {
      pushRoute('VisualisasiFuseki')
    }

    const goToTentangKami = () => {
      pushRoute('TentangKami')
    }

    const navigateTo = (kategori) => {
      const routeMap = {
        Tokoh: 'Tokoh',
        Tempat: 'TempatAsal',
        Pusaka: 'PusakaList',
        Kesaktian: 'KesaktianList'
      }
      const routeName = routeMap[kategori]
      if (routeName) {
        pushRoute(routeName)
      }
    }

    return {
      goHome,
      goToVisualisasi,
      goToVisualisasiFuseki,
      goToTentangKami,
      navigateTo
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: var(--sidebar-width);
  background: linear-gradient(180deg, #fffaf0 0%, #fff3dd 100%);
  height: 100vh;
  padding: 20px;
  border-right: 1px solid #ebc48a;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  position: fixed;
  inset: 0 auto 0 0;
  z-index: 1200;
  box-shadow: 12px 0 24px rgba(95, 61, 20, 0.08);
}

.sidebar-header {
  margin-bottom: 20px;
}

.sidebar-header h1 {
  font-size: 20px;
  font-weight: bold;
  color: #6f3e06;
  margin-bottom: 10px;
  line-height: 1.3;
}

.nav-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

button {
  background: linear-gradient(120deg, #f3bb62, #ffdfab);
  color: #5c3307;
  border: 1px solid #d59e4e;
  padding: 9px 12px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: bold;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  text-align: left;
}

button:hover {
  transform: translateY(-1px);
  box-shadow: 0 7px 14px rgba(111, 62, 6, 0.2);
}

.submenu {
  margin-top: 30px;
}

.submenu h2 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.menu-section {
  margin-bottom: 20px;
}

.menu-section h3 {
  font-size: 16px;
  margin-bottom: 5px;
  color: #8b5317;
}

.menu-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-section li {
  margin: 8px 0;
}

.menu-link {
  width: 100%;
  border: none;
  padding: 0;
  background: transparent;
  color: #3c2b1e;
  font-weight: 500;
  transition: color 0.2s ease;
  cursor: pointer;
  text-align: left;
}

.menu-link::before {
  content: "➤";
  margin-right: 8px;
  color: #8b5317;
}

.menu-link:hover {
  color: #8b5317;
  text-decoration: underline;
  text-underline-offset: 3px;
}

@media (max-width: 960px) {
  .sidebar {
    transform: translateX(-100%);
    transition: transform 0.25s ease;
  }

  .sidebar.is-open {
    transform: translateX(0);
  }
}
</style>
